import { render, staticRenderFns } from "./CardColor.vue?vue&type=template&id=a30b7a58&"
import script from "./CardColor.vue?vue&type=script&lang=js&"
export * from "./CardColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports